// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Ejjk","validationTips":"StatementDescriptor_validationTips__3HDFR"};